export default __webpack_public_path__ + "static/1464-9eb7a94cfce98c8fb0b2aa60457f0ef2.gif";